import queryString from "query-string";
import {Columns} from "./Columns";
import {readStorage} from "../../redux/LocalStorage/helpers/readStorage";
// import { TransactionColKey } from "../../enums/TransactionColKey";

export function getParsedColumns(
    storageKey,
    props = {},
    fields = [],
) {
    // Part 1: Get Columns
    const {
        getColumns = () => {},
        sortable = [],
        required = [],
        defaulto = [],
        hideTitle = [],
    } = Columns[storageKey] || {};

    const columns = getColumns(props, fields);

    // Part 2: Get params (from query) and storage data (from local storage)
    const params = queryString.parse(window?.location?.search);
    const storageData = readStorage(storageKey) || {};

    // Part 3: Sorting
    const sortBy = params.sort_by || storageData.sort_by;
    let sortDir = params.sort_dir || storageData.sort_dir;

    if (sortDir === 'asc')
        sortDir = 'ascend';
    if (sortDir === 'desc')
        sortDir = 'descend';

    return columns.map(column => {
        const newColumns = {...column};

        // Part 4: Handle Sortable
        if (
            sortable.includes(column.key)
            // || (
            //     sortable.includes(column.colKeyGroup) &&
            //     column.colKeyGroup === TransactionColKey.custom_fields
            // )
        ) {
            newColumns.sorter = true;
            newColumns.sortOrder = sortBy === (column.dataIndex || column.key) ? sortDir : false;
        }
        if (column.sorter === true)
            newColumns.sortOrder = sortBy === (column.dataIndex || column.key) ? sortDir : false;

        // Part 5: Handle Required
        if (required.includes(column.key))
            newColumns.required = true;

        // Part 6: Handle Default
        if (defaulto.includes(column.key))
            newColumns.defaulto = true;

        // Part 7: Handle Hide Titles
        newColumns.label = newColumns.label || newColumns.title;
        if (hideTitle.includes(column.key))
            newColumns.title = null;

        return newColumns;
    });
}
